import * as React from 'react';
import { Layout, Card, Cell, Text, Divider, Box } from '@wix/design-system';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { frequencyTranslations } from '../../RecurringPayView/RecurringPayView';
export const UNTIL_CANCELED_OPTION = 0;
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["FORTNIGHTLY"] = "FORTNIGHTLY";
})(BillingCycle || (BillingCycle = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["AUTOMATIC"] = "automatic";
})(PaymentType || (PaymentType = {}));
const paymentTypeKeys = {
    [PaymentType.AUTOMATIC]: 'recurring-details.payment-type.auto',
};
const RecurringDetailsCard = ({ t, paymentType, billingCycle, recurringPayment, totalRecurringPayments, }) => {
    return (React.createElement(Card, null,
        React.createElement(Box, { maxHeight: "54px", verticalAlign: "middle", dataHook: "recurring-details-card" },
            React.createElement(Card.Content, null,
                React.createElement(Box, { marginTop: "6px" },
                    React.createElement(Layout, { gap: "0px", justifyItems: "left" },
                        React.createElement(Cell, { span: 3 },
                            React.createElement(Box, { direction: "horizontal" },
                                React.createElement(Box, { paddingRight: "24px" },
                                    React.createElement(Text, { secondary: true, size: "small", weight: "thin", dataHook: "payment-type-title" },
                                        React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.payment-type.title'))),
                                    React.createElement(Text, { secondary: true, size: "small", weight: "normal", dataHook: "payment-type" }, t(paymentTypeKeys[paymentType]))),
                                React.createElement(Divider, { direction: "vertical" }))),
                        React.createElement(Cell, { span: 3 },
                            React.createElement(Box, { direction: "horizontal", paddingLeft: "24px" },
                                React.createElement(Text, { secondary: true, size: "small", weight: "thin", dataHook: "billing-cycle-title" },
                                    React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.billing-cycle.title'))),
                                React.createElement(Text, { secondary: true, size: "small", weight: "normal", dataHook: "billing-cycle" }, t(frequencyTranslations[billingCycle.toLowerCase()])))),
                        React.createElement(Cell, { span: 6 },
                            React.createElement(Box, { direction: "horizontal" },
                                React.createElement(Box, { paddingRight: "24px" },
                                    React.createElement(Divider, { direction: "vertical" })),
                                React.createElement(Text, { secondary: true, size: "small", weight: "thin", dataHook: "recurring-payment-title" },
                                    React.createElement(Box, { whiteSpace: "pre" }, t('recurring-details.recurring-payment.title'))),
                                React.createElement(Text, { secondary: true, size: "small", weight: "normal", dataHook: "recurring-payment" }, totalRecurringPayments === UNTIL_CANCELED_OPTION
                                    ? t('recurring-details.recurring-payment.unlimited')
                                    : t('recurring-details.recurring-payment.value', {
                                        recurringPayment,
                                        totalRecurringPayments,
                                    }))))))))));
};
export default withTranslation(['invoice-view', 'locale-data'])(RecurringDetailsCard);
//# sourceMappingURL=RecurringDetailsCard.js.map